import React, { useState } from "react";
import styles from "./index.module.css";
import { MdOutlineOpenInNew } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { TRIP_STATUS } from "../../../helpers/constants";
import SwipeButton from "../../../Components/SwipeButton";
import { FaRegStickyNote } from "react-icons/fa";

const DestinationDetails = ({
  destinationDetails,
  activeStep,
  handleMultiComplete,
  toggleShowMore,
  setData,
  handleClickNotes,
  shifterType,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {destinationDetails.map((item, key) => (
        <div
          className={styles["generic-transport__data-container--location"]}
          key={key}
        >
          <label
            className={
              styles["generic-transport__data-container--location__area"]
            }
          >
            {item?.area?.name}
            {item?.notes && (
              <FaRegStickyNote
                color="#2c4861"
                size={16}
                onClick={() => handleClickNotes(item?.notes)}
              />
            )}
          </label>
          <label
            className={
              styles["generic-transport__data-container--location__building"]
            }
          >
            {`${item?.floor?.name}, ${item?.building?.name}`}
          </label>
          {
            <div
              className={
                styles[
                  "generic-transport__data-container--location__building__more"
                ]
              }
            >
              {item?.transport_types?.map((type, val) => (
                <span
                  key={val}
                  className={
                    styles[
                      "generic-transport__data-container--location__building__task-types"
                    ]
                  }
                >
                  <label>{type?.name}</label>
                  {type?.equipments?.length > 0 && (
                    <MdOutlineOpenInNew
                      size={20}
                      color="#2c4861"
                      onClick={() => {
                        toggleShowMore(true);
                        setData(type?.equipments);
                      }}
                    />
                  )}
                </span>
              ))}
            </div>
          }
          {destinationDetails?.length > 1 &&
            activeStep === 3 &&
            item?.status === TRIP_STATUS.BOOKED &&
            shifterType === "primary" && (
              <SwipeButton
                onComplete={() => handleMultiComplete(item?.area?.id)}
                label={t("Arrived")}
                applyRest
              />
            )}
          {item?.status === TRIP_STATUS.COMPLETE && (
            <span className={styles["generic-transport__complete"]}>
              {t("Destination Covered")}
            </span>
          )}
        </div>
      ))}
    </>
  );
};
export default DestinationDetails;
